module.exports = __webpack_public_path__ + "static/media/SWAMP-BNB.03dccbc5.svg";